export default __webpack_public_path__ + "static/media/how-goals-2.bff89ce3.png";